import { localStorage as local } from '@entrata/utils'
import { SETUP_DATA_KEY } from 'portal-modules/common/constants/keys'
import { call } from 'redux-saga/effects'
import {
  setEncryptedCryptoData,
  getDecryptedCryptoData,
} from 'portal-modules/common/utils/crypto-encryption'

export const removeByKey = key => data =>
  Object.entries(data).reduce((obj, [curKey, value]) => {
    if (curKey === key) return obj
    return { ...obj, [curKey]: value }
  }, {})

export function* clearSetupData(userKey) {
  const data = yield call(getDecryptedCryptoData, SETUP_DATA_KEY) || {}

  if (data && data[userKey]) {
    if (Object.keys(data).length > 1) {
      yield call(
        setEncryptedCryptoData,
        SETUP_DATA_KEY,
        removeByKey(userKey)(data),
      )
    } else {
      yield call(local.remove, SETUP_DATA_KEY)
    }
  }
}

export const clearSetupDataSync = userKey => {
  const data = getDecryptedCryptoData(SETUP_DATA_KEY) || {}

  if (data && data[userKey]) {
    if (Object.keys(data).length > 1) {
      setEncryptedCryptoData(SETUP_DATA_KEY, removeByKey(userKey)(data))
    } else {
      local.remove(SETUP_DATA_KEY)
    }
    return true
  }
  return false
}

export function* addSetupData(userKey, data) {
  const setupData = yield call(getDecryptedCryptoData, SETUP_DATA_KEY)
  yield call(setEncryptedCryptoData, SETUP_DATA_KEY, {
    ...(setupData || {}),
    [userKey]: data,
  })
}
